import { META_PIXEL_ID } from "@/api/session";

const META_PIXEL_SCRIPT_SRC = "https://connect.facebook.net/en_US/fbevents.js";
let isMetaPixelInitialized = false;
let hasAdvancedMatching = false;

function isCliprHostname() {
  return window.location.hostname.endsWith("clipr.tv");
}

function hasValues(payload) {
  return !!payload && Object.keys(payload).length > 0;
}

function compactPayload(payload) {
  if (!payload || typeof payload !== "object") return null;
  const filteredEntries = Object.entries(payload).filter(([, value]) => (
    value !== undefined && value !== null && value !== ""
  ));
  if (!filteredEntries.length) return null;
  return Object.fromEntries(filteredEntries);
}

function ensureFbq() {
  if (typeof window === "undefined" || typeof document === "undefined") return null;
  if (typeof window.fbq === "function") return window.fbq;

  const fbq = function fbqProxy(...args) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args);
      return;
    }
    fbq.queue.push(args);
  };

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  window.fbq = fbq;
  if (!window._fbq) {
    window._fbq = fbq;
  }

  if (!document.querySelector(`script[src="${META_PIXEL_SCRIPT_SRC}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = META_PIXEL_SCRIPT_SRC;
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }

  return fbq;
}

export function initMetaPixel(advancedMatching = null) {
  if (!isCliprHostname()) return false;

  const fbq = ensureFbq();
  if (!fbq) return false;

  const safeAdvancedMatching = compactPayload(advancedMatching);
  const wantsAdvancedMatching = hasValues(safeAdvancedMatching);

  if (isMetaPixelInitialized) {
    if (wantsAdvancedMatching && !hasAdvancedMatching) {
      fbq("init", META_PIXEL_ID, safeAdvancedMatching);
      hasAdvancedMatching = true;
    }
    return true;
  }

  if (wantsAdvancedMatching) {
    fbq("init", META_PIXEL_ID, safeAdvancedMatching);
    hasAdvancedMatching = true;
  } else {
    fbq("init", META_PIXEL_ID);
  }
  isMetaPixelInitialized = true;
  return true;
}

export function trackPageView() {
  if (!initMetaPixel()) return;
  window.fbq("track", "PageView");
}

export function trackMetaStandardEvent(eventName, payload = null, options = null) {
  if (!eventName || !initMetaPixel()) return;

  const safePayload = compactPayload(payload);
  const safeOptions = compactPayload(options);
  const hasPayload = hasValues(safePayload);
  const hasOptions = hasValues(safeOptions);

  if (hasPayload && hasOptions) {
    window.fbq("track", eventName, safePayload, safeOptions);
    return;
  }
  if (hasPayload) {
    window.fbq("track", eventName, safePayload);
    return;
  }
  window.fbq("track", eventName);
}

export function trackMetaCustomEvent(eventName, payload = null, options = null) {
  if (!eventName || !initMetaPixel()) return;

  const safePayload = compactPayload(payload);
  const safeOptions = compactPayload(options);
  const hasPayload = hasValues(safePayload);
  const hasOptions = hasValues(safeOptions);

  if (hasPayload && hasOptions) {
    window.fbq("trackCustom", eventName, safePayload, safeOptions);
    return;
  }
  if (hasPayload) {
    window.fbq("trackCustom", eventName, safePayload);
    return;
  }
  window.fbq("trackCustom", eventName);
}
